<script setup>
  import {computed} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {Link as InertiaLink} from "@inertiajs/vue3";
  import {MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentPagination",
  });

  const props = defineProps({
    links: {
      type: Array,
      default: () => [],
    },
  });

  const isVisible = computed(() => props.links.length > 3);
  const previousLink = computed(() => (isVisible.value ? props.links[0] : null));
  const nextLink = computed(() => (isVisible.value ? props.links.at(-1) : null));
</script>

<template>
  <nav v-if="isVisible" class="flex items-center justify-between" :data-test="getTestId('pagination')">
    <div class="-mt-px flex w-0 flex-1">
      <Component
        :is="previousLink.url ? InertiaLink : 'span'"
        :href="previousLink.url"
        class="inline-flex items-center border-t-2 py-4 pr-4 pl-0 text-sm font-medium hover:no-underline md:pl-4"
        :class="{
          'border-transparent text-gray-500': !previousLink.active,
          'text-mc-red border-mcred': previousLink.active,
          'hover:border-gray-300 hover:text-gray-700': previousLink.url,
        }"
        :data-test="getTestId(`pagination-prev-page-${previousLink.url ? 'inertia-link' : 'span'}`)"
      >
        <MedTooltip content="vorherige Seite">
          <ComponentIcon>arrow_back_ios</ComponentIcon>
        </MedTooltip>

        <div class="px-2 md:hidden">vorherige Seite</div>
      </Component>
    </div>

    <div class="hidden md:-mt-px md:flex">
      <Component
        :is="link.url ? InertiaLink : 'span'"
        v-for="link in links.slice(1, -1)"
        :key="'pagination-' + link.label"
        :href="link.url"
        class="inline-flex items-center border-t-2 p-4 text-sm font-medium hover:no-underline"
        :class="{
          'border-transparent text-gray-500': !link.active,
          'text-mc-red border-mcred': link.active,
          'hover:border-gray-300 hover:text-gray-700': link.url,
        }"
        :data-test="getTestId(`pagination-set-page-${link.url ? 'inertia-link' : 'span'}`)"
      >
        {{ link.label }}
      </Component>
    </div>

    <div class="-mt-px flex w-0 flex-1 justify-end">
      <Component
        :is="nextLink.url ? InertiaLink : 'span'"
        :href="nextLink.url"
        class="inline-flex items-center border-t-2 py-4 pr-0 pl-4 text-sm font-medium hover:no-underline md:pr-4"
        :class="{
          'border-transparent text-gray-500': !nextLink.active,
          'text-mc-red border-mcred': nextLink.active,
          'hover:border-gray-300 hover:text-gray-700': nextLink.url,
        }"
        :data-test="getTestId(`pagination-next-page-${nextLink.url ? 'inertia-link' : 'span'}`)"
      >
        <div class="px-2 md:hidden">nächste Seite</div>

        <MedTooltip content="nächste Seite">
          <ComponentIcon>arrow_forward_ios</ComponentIcon>
        </MedTooltip>
      </Component>
    </div>
  </nav>
</template>
